import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { FloComponentProps } from 'components';



type AreaChartStyle = {
  height?: string;
  width?: string;
}

type AreaChartSerie = {
  name: string;
  data: number[];
}

export type FloChartFormatterFunction = (params: Array<any>, ticket: any, callback: any) => any;

interface FloBasicAreaChartProps extends FloComponentProps {
  style?: AreaChartStyle;
  yAxisLabel?: string;
  xAxisData: string[];
  series: AreaChartSerie[];
  formatter?: FloChartFormatterFunction;
  isLoading?: boolean,
}

export const FloBasicAreaChart: React.FC<FloBasicAreaChartProps> = React.memo(({
  style = { height: '400px' },
  yAxisLabel = '',
  xAxisData,
  series,
  formatter,
  isLoading = false,
}) => {

  const option = {
    tooltip : {
      trigger: 'axis',
      formatter
    },
    calculable : true,
    xAxis : [
      {
          type : 'category',
          boundaryGap : false,
          data : xAxisData,
      }
    ],
    yAxis : [
      {
        type: 'value',
        name: yAxisLabel,
        nameTextStyle:{ color: "#899AA6" },
      }
    ],
    series : series.map(s => ({
      ...s,
      type:'line',
      smooth: false,
      itemStyle: {normal: {areaStyle: {type: 'default', color: '#8DD0FB'}}},
    }))
};
  return (
    <ReactEcharts
      option      = {option}
      notMerge    = {false}
      style       = {style}
      showLoading = {isLoading}
      theme       = "my_theme"
      loadingOption = {{
        color: 'rgb(68, 178, 29)',
      }}
      lazyUpdate = {true}
    />
  )
})